import { FC, HTMLAttributes, InputHTMLAttributes, ReactNode } from "react";
import { _ } from "../../utils/helpers";
import { ErrorInfo, Falsy } from "../../types";

interface CheckBoxProps extends InputHTMLAttributes<HTMLInputElement> {
    children: ReactNode
    getError: (value: boolean) => Falsy | ErrorInfo
}

export const CheckBox:FC<CheckBoxProps> = ({children, getError, ...rest}) => {


    const error = getError(Boolean(rest.checked))

    return (
        <div id={`${rest.id}-container`} className={`df fd-c form-row w-100 checkbox-container ${ error ? 'has-error' : ''}`}>
            <label className="text s18-400 df aifs">
                <input 
                    {...rest}
                    type="checkbox"
                    className={`mr-5 checkbox ${rest.className}`}
                />
                {children}
            </label>
            <span 
                id={`${rest.id}-error`} 
                className="input-error text s18-400 w-100"
            >
                {error ? _(error.message) : ''}
            </span>
        </div>
    )
}